import type { ReactNode } from 'react';
import { useRef, useState } from 'react';
import { PdpArrowDown, transformTextToId } from '@storefront/lib-global';
import { sendAccordionClickEvent } from '@storefront/lib-global/utils/gtm/events/accordion_click/sendAccordionClickEvent';
import { useGetLineHeight } from '../../../../hooks';
import { AccordionHeading, Container, Content, MaterialsAndCareAccordion } from './MaterialsAndCare.styles';

export interface MaterialsAndCareProps {
  children: ReactNode;
  header: string;
}

export function MaterialsAndCare({ children, header }: MaterialsAndCareProps) {
  const [isOpen, setIsOpen] = useState(false);
  const textElRef = useRef<HTMLSpanElement>(null);
  const lineHeight = useGetLineHeight(textElRef);

  const handleToggle = () => {
    if (!isOpen) {
      sendAccordionClickEvent('Materials and Care');
    }
    setIsOpen((prev) => !prev);
  };

  return (
    <Container>
      <hr />
      <AccordionHeading>
        <MaterialsAndCareAccordion
          aria-label={header}
          type="button"
          onClick={handleToggle}
          $lineHeight={lineHeight}
          $isOpen={isOpen}
          aria-expanded={isOpen}
          aria-controls={`accordion-container-${transformTextToId(header)}`}
        >
          <span ref={textElRef}>{header}</span>
          <PdpArrowDown aria-hidden className="accordion-arrow-down" />
        </MaterialsAndCareAccordion>
      </AccordionHeading>
      <Content $isOpen={isOpen} aria-hidden={!isOpen} id={`accordion-container-${transformTextToId(header)}`}>
        {children}
      </Content>
      <hr />
    </Container>
  );
}
